<!-- Mobile -->
<div class="d-block d-md-none">
    <div *ngIf="vm.rowsFiltered.length">
        <mdb-accordion [multiple]="false" aria-multiselectable="true">
            <mdb-accordion-item [collapsed]="true">
                <mdb-accordion-item-head> {{vm.data.title}}</mdb-accordion-item-head>
                <mdb-accordion-item-body>
                    <div *ngIf="vm.select && vm.select.options && vm.select.options.length">
                        <select class="browser-default custom-select select-box" (ngModelChange)="getSelectedValue(vm, $event)" [ngModel]="selectedValue">
                            <option *ngFor="let o of vm.select.options;" [value]="o.value">
                                {{o.label}}
                              </option>
                          </select>
                    </div>
                    <div *ngFor="let r of vm.rowsFiltered; index as i">
                        <mdb-card cascade="true" narrower="true" class="pt-3">
                            <div class="row" *ngIf="keyColumn >= 0">
                                <div class="col-9 col-sm-8">
                                    <div *ngIf="vm.styleTypesFiltered && vm.styleTypesFiltered.length" [ngClass]="getMobileClass(vm.styleTypesFiltered[i].rowStyle)">
                                        <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                    </div>
                                    <div *ngIf="!vm.styleTypesFiltered || !vm.styleTypesFiltered.length">
                                        <h4 class="card-header-title">{{r.fields[keyColumn]}}</h4>
                                    </div>
                                </div>
                            </div>
                            <mdb-card-body cascade="true" class="pb-0 px-2">
                                <mdb-card-text>
                                    <div *ngFor="let f of r.fields; index as c">
                                        <div class="row" *ngIf="c != keyColumn">
                                            <div class="col-5 text-right"><b>{{vm.data.columns[c]}}:</b></div>
                                            <div class="col-7">
                                                <strong>
                                                    <span [ngClass]="{'warning-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==1 && vm.styleTypesFiltered[i].cellToApplyStyle == c, 'danger-cell': vm.styleTypesFiltered && vm.styleTypesFiltered.length && vm.styleTypesFiltered[i].cellStyle && vm.styleTypesFiltered[i].cellStyle==2 && vm.styleTypesFiltered[i].cellToApplyStyle == c}">
                                                        {{f}}</span>
                                                </strong></div>
                                        </div>
                                    </div>
                                    <div *ngIf="includeAction" class="d-flex justify-content-start">
                                        <button mdbBtn color="default" type="button" outline="true" rounded="true"
                                            size="sm" mdbWavesEffect
                                            (click)="action(r.fields[keyColumn], vm.data.title)">{{
                                            r.actionTitle
                                            ||
                                            'validate'}}
                                        </button>
                                    </div>
                                </mdb-card-text>
                            </mdb-card-body>
                        </mdb-card>
                    </div>
                </mdb-accordion-item-body>
            </mdb-accordion-item>
        </mdb-accordion>
    </div>
</div>

<!-- Desktop-->
<div class="d-none d-md-block">
    <div class="row">
        <div class="col-md-12">
            <div class="col-md-3 offset-md-9 mb-0">
                <div class="form-inline md-form form-sm my-0">
                    <mdb-icon fas icon="search" aria-hidden="true"></mdb-icon>
                    <input type="text" [(ngModel)]="searchText" class="form-control" id="search" mdbInput />
                </div>
            </div>
        </div>
    </div>
    <mdb-card narrower="true" cascade="true">
        <app-card-header [title]="vm.data.title" [headingSize]="3"></app-card-header>
        <mdb-card-body cascade="true">
            <div class="col-md-12">
                <table mdbTable #tableEl="mdbTable" class="z-depth-1" striped="true" hover="true" small="true">
                    <thead>
                        <tr>
                            <th *ngFor="let c of vm.data.columns; let i = index" scope="col">{{c | titlecase}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of vm.rowsFiltered; let i = index">
                            <ng-container *ngFor="let f of r.fields">
                                <td
                                    *ngIf="i+1 >= mdbTablePagination.firstItemIndex && i < mdbTablePagination.lastItemIndex">
                                    {{f}}
                                </td>
                            </ng-container>
                        </tr>
                    </tbody>
                    <tfoot class="grey lighten-5 w-100">
                        <tr>
                            <td colspan="4">
                                <mdb-table-pagination [tableEl]="tableEl" [searchDataSource]="vm.rowsFiltered">
                                </mdb-table-pagination>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </mdb-card-body>
    </mdb-card>
</div>